<div class="repeat-wrapper">
  <div class="repeat-item" *ngFor="let f of field.fieldGroup; let i = index">
    <formly-field [field]="f"></formly-field>
    <button mat-icon-button type="button" aria-label="Remove" (click)="remove(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="repeat-actions">
    <button mat-stroked-button color="primary" type="button" (click)="add()">
      {{ field.templateOptions?.['addText'] || 'Add' }}
    </button>
  </div>
</div>
